export default {
  maintenaceSlogan: 'We will Be Back Soon!',
  maintenanceMessage:
    // 'We are currently performing scheduled maintenance to improve our services for you. We apologize for the inconvenience and appreciate your patience. Please check back later',
    "We are currently on hiatus while we enhance our platform for a better wallet app experience. Thank you for your patience—we'll be back soon!",
  maintenanceAction: 'Need assistance?',
  linkToDiscord: 'Reach out our support team',
}
